import { Feature, InjectorService } from '@tencent/workbench';
import { SolidFill as SolidFillColor } from '@src/slide/domain/ui-model/plugin/referModels/FillClass';
import { BaseFillFeature } from '@framework/workbench/drawer/ui/fill/base/base-fill-feature';
import { FillType } from '@framework/workbench/drawer/ui/fill/constants';
import { TdwDrawerConstMap, tdwDrawerReport } from '@framework/workbench/drawer/report';
import { SolidFillFeature } from '@framework/workbench/drawer/ui/fill/solid-fill/solid-fill-feature';
import { GradualFillFeature } from '@framework/workbench/drawer/ui/fill/gradual-fill/gradual-fill-feature';
import { ImageFillFeature } from '@framework/workbench/drawer/ui/fill/image-fill/image-fill-feature';
import { IBackgroundFillFeature } from '@tencent/drawing-drawer-components';

@Feature()
export class BackgroundFillFeature extends BaseFillFeature implements IBackgroundFillFeature {
    public curFillType;
    private solidFillFeature: SolidFillFeature;
    private gradualFillFeature: GradualFillFeature;
    private imageFillFeature: ImageFillFeature;
    public constructor() {
        super();
        this.solidFillFeature = InjectorService.get(SolidFillFeature);
        this.gradualFillFeature = InjectorService.get(GradualFillFeature);
        this.imageFillFeature = InjectorService.get(ImageFillFeature);
    }

    /**
     * 应用到全部
     */
    public handleApplyToAllSlide = (): void => {
        if (this.isSlideBg) {
            const bgProps = this.getSlideBgProps();
            this.getUiDataService().presentation.useSlideBgInMaster(bgProps);
            tdwDrawerReport(TdwDrawerConstMap.applyAllBg);
        }
    };

    /**
     * 重置背景
     */
    public handleSlideBackgroundReset = (): void => {
        if (this.isSlideBg) {
            this.getSelectionService().currentSlide?.getBackgroundFill().updateCurrentFill({});
            tdwDrawerReport(TdwDrawerConstMap.resetBg);
        }
    };

    private getSlideBgProps = () => {
        const map = {
            [FillType.SOLID_FILL]: { solidFill: new SolidFillColor(this.solidFillFeature.getSolidProps()) },
            [FillType.GRADUAL_FILL]: this.gradualFillFeature.getGradualProps(),
            [FillType.IMAGE_FILL]: this.imageFillFeature.getImageProps(),
            [FillType.NO_FILL]: { noFill: 1 },
        };
        const { fillType } = this;
        if (map[fillType]) {
            return map[fillType];
        }
    };
}
